const REMEMBER_ME_KEY = 'auth0_remember_me';

function readRememberMeFlag(): boolean {
  try {
    const raw = localStorage.getItem(REMEMBER_ME_KEY);
    if (raw === null) return true; // default to persistent when unset
    return raw === 'true';
  } catch {
    return true;
  }
}

let usePersistentStorage = readRememberMeFlag();

export function setRememberMe(remember: boolean): void {
  try {
    localStorage.setItem(REMEMBER_ME_KEY, remember ? 'true' : 'false');
  } catch { }
  usePersistentStorage = remember;
}

export function isRememberMeEnabled(): boolean {
  return usePersistentStorage;
}

/**
 * Clear any locally cached auth tokens.
 * Auth0 SDK manages its own token cache in localStorage when
 * cacheLocation="localstorage", so this clears the old Keycloak keys
 * and can be extended if custom caching is added later.
 */
export function clearTokens(): void {
  try {
    // Remove legacy Keycloak token keys (migration cleanup)
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refresh_token');
    sessionStorage.removeItem('kc_token');
    sessionStorage.removeItem('kc_refresh_token');
  } catch { }
}
